import { useState, useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { ModalForm } from '@/components/common/Modal'
import { TextInput, SelectInput, CheckboxInput } from '@/components/common/FormField'
import { departmentService } from '@/services/api'
import api from '@/services/api'
import toast from 'react-hot-toast'

const INITIAL = { name: '', department: '', is_active: true }

export default function PositionModal({ open, onClose, position = null, defaultDepartment = null }) {
    const qc = useQueryClient()
    const [form, setForm] = useState(INITIAL)
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)
    const isEdit = !!position

    const { data: depts } = useQuery({
        queryKey: ['departments-list'],
        queryFn: () => departmentService.list({ page_size: 200 }).then((r) => r.data.results || r.data),
        enabled: open,
    })

    useEffect(() => {
        if (open) {
            setForm(position ? {
                name: position.name || '',
                department: position.department || defaultDepartment || '',
                is_active: position.is_active ?? true,
            } : { ...INITIAL, department: defaultDepartment || '' })
            setErrors({})
        }
    }, [open, position, defaultDepartment])

    const set = (key) => (e) => {
        const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        setForm((f) => ({ ...f, [key]: val }))
        if (errors[key]) setErrors((er) => ({ ...er, [key]: '' }))
    }

    const validate = () => {
        const e = {}
        if (!form.name.trim()) e.name = 'Обязательное поле'
        if (!form.department) e.department = 'Выберите отдел'
        setErrors(e)
        return Object.keys(e).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validate()) return
        setLoading(true)
        try {
            if (isEdit) {
                await api.patch(`/departments/positions/${position.id}/`, form)
                toast.success('Должность обновлена')
            } else {
                await api.post('/departments/positions/', form)
                toast.success('Должность создана')
            }
            qc.invalidateQueries(['departments-full'])
            onClose()
        } catch (err) {
            const data = err.response?.data
            if (data?.name) setErrors({ name: Array.isArray(data.name) ? data.name[0] : data.name })
            else toast.error(data?.detail || 'Ошибка сохранения')
        } finally {
            setLoading(false)
        }
    }

    const deptOptions = (depts || []).map((d) => ({ value: d.id, label: d.name }))

    return (
        <ModalForm
            open={open}
            onClose={onClose}
            title={isEdit ? 'Редактировать должность' : 'Добавить должность'}
            onSubmit={handleSubmit}
            loading={loading}
        >
            <SelectInput
                label="Отдел" required
                value={form.department} onChange={set('department')}
                options={deptOptions} placeholder="Выберите отдел"
                error={errors.department}
            />
            <TextInput
                label="Название должности" required
                value={form.name} onChange={set('name')}
                error={errors.name}
                placeholder="Главный специалист"
            />
            <CheckboxInput
                label="Активно"
                checked={form.is_active}
                onChange={set('is_active')}
            />
        </ModalForm>
    )
}
